import { render, staticRenderFns } from "./BtnReset.vue?vue&type=template&id=40f2f4e0"
import script from "./BtnReset.vue?vue&type=script&lang=js"
export * from "./BtnReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports